const travelTimeReport = {
    namespaced: true,
    state: {
        linesWithRoutes: {},
        travelTimeReportList: [],
        currentStopList: [],
        dayTypes: []
    },
    mutations: {
        updateLinesWithRoutes(state, newLinesWithRoutes) {
            state.linesWithRoutes = newLinesWithRoutes;
        },
        updateTravelTimeReportList(state, newList) {
            state.travelTimeReportList = newList;
        },
        updateCurrentStopList(state, newList) {
            state.currentStopList = newList;
        },
        updateDayTypes(state, newList) {
            state.dayTypes = newList;
        }
    },
    actions: {
        getLinesWithRoutes(context) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/traveltimereport/getLinesWithRoutes')
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('updateLinesWithRoutes', response.data);
                        }
                        resolve(response);
                    }),
                error => {
                    reject(error);
                }
            });
        },
        getRouteStops(context, routeId) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/traveltimereport/getRouteStops', { params: { "route": routeId } })
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('updateCurrentStopList', response.data);
                        }
                        resolve(response);
                    }),
                error => {
                    reject(error);
                }
            });
        },
        getTravelTimeReportList(context, data) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/traveltimereport/getTravelTimeReportList', { params: data })
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('updateTravelTimeReportList', response.data);
                        }
                        resolve(response);
                    }),
                error => {
                    reject(error);
                }
            });
        },
        exportXLS(context, data) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/traveltimereport/exportXLS', { params: data, responseType: 'blob' })
                    .then(response => {
                        const blob = new Blob([response.data], { type: 'application/xlsx' })
                        const link = document.createElement('a')
                        link.href = URL.createObjectURL(blob)
                        link.download = 'travel_time_report.xlsx'
                        link.click()
                        URL.revokeObjectURL(link.href)

                        resolve(response);
                    }),
                error => {
                    reject(error);
                }
            });
        },
        getDayTypes(context) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/traveltimereport/getDayTypes')
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('updateDayTypes', response.data);
                        }
                        resolve(response);
                    }),
                error => {
                    reject(error);
                }
            });
        }
    }
}
export default travelTimeReport;